import { PropsWithChildren, FC, useContext, useEffect, CSSProperties } from "react";
import { GlobalContext } from "../hooks/useGlobal";
import { RouteList } from "../Routes";
import { useHistory } from "react-router-dom";
import { Constants } from "../utils/Constants";
import clsx from "clsx";

type Props = {
    auth?: "public" | "private";
    anchorTop?: boolean;
    className?: string;
    style?: CSSProperties;
};

export const Page: FC<Props> = (props: PropsWithChildren<Props>) => {
    const { auth, anchorTop, className, children, style } = props;
    const { webUrl } = Constants;

    const { isAuthenticated } = useContext(GlobalContext);
    const history = useHistory();

    // redirect public only pages to the home page for authenticated users
    if (auth === "public" && isAuthenticated()) {
        history.push(RouteList.Home);
    }

    // redirect private pages to Writelike for unauthenticated users
    if (auth === "private" && !isAuthenticated()) {
        window.location.replace(webUrl);
    }

    useEffect(() => {
        // scroll page to top on route change
        window.scroll(0, 0);
    }, []);

    return <div style={style} className={clsx("trans", anchorTop && "trans--top", className)}>{children}</div>;
};

Page.defaultProps = {
    auth: "private",
    anchorTop: false,
};
